import styled from 'styled-components';
import { StyledActionIconButton } from './page';
import { CardActionButton } from './component';

export const StyledDataButtonPanelContainer = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--space-2);
    border-radius: var(--radius-lg);
    font-size: var(--text-sm);
    line-height: 1.5;
    margin: 0;
    margin-left: var(--space-4);
    width: auto;
    min-height: 44px;
    outline: none !important;
    padding: 0;
    text-align: center;
    text-shadow: none;
    position: relative;
    z-index: 10;
    justify-content: flex-start;
    flex-shrink: 0;
    
    .anticon {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
    }
    
    button {
        color: white;
        border-radius: var(--radius-md);
        outline: none !important;
        cursor: pointer;
        font-family: var(--font-primary);
        font-weight: var(--font-semibold);
        transition: all var(--transition-base);
        display: flex;
        align-items: center;
        justify-content: center;
        
        &:hover {
            transform: translateY(-2px);
            box-shadow: var(--shadow-lg);
        }
        
        &:active {
            transform: translateY(0);
        }
    }
    
    .save-button {
        flex: 1;
        font-size: var(--text-base);
        border: none;
        font-weight: var(--font-bold);
        box-shadow: var(--shadow-md);
        height: 44px;
        line-height: 1;
        background: var(--accent-primary);
        padding: 0 var(--space-4);
        min-width: 120px;
        
        &:focus, &:active {
            color: white;
        }
        
        &:hover {
            background-color: var(--accent-primary-hover);
        }
    }
    
    #save-button-waiting {
        cursor: wait;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 1;
    }
    
    #save-button-ready {
        cursor: pointer;
        
        &:hover {
            background-color: var(--accent-primary-hover);
            box-shadow: var(--shadow-lg);
        }
    }
    
    .save-button-container {
        display: flex;
        flex: 0 0 auto;
        font-size: var(--text-base);
        line-height: 1.35;
        position: relative;
    }
    
    .save-button-tainted {
        .alert-label {
            flex: 1;
            padding-top: var(--space-1);
            color: var(--status-error);
            font-size: var(--text-sm);
        }
        
        .resolution-option {
            position: relative;
            border: none;
            border-radius: var(--radius-md);
            background: transparent;
        }
    }
    
    .save-button-dropdown {
        .resolution-option {
            background: transparent;
            border-left: 1px solid rgba(255, 255, 255, 0.2);
            
            &:hover {
                background: rgba(255, 255, 255, 0.1);
            }
        }
    }
    
    .imexport {
        flex: 0 0 auto;
        display: flex;
        flex-direction: column;
        gap: var(--space-2);
        align-items: stretch;
        min-width: 120px;
        
        > div:nth-child(2) {
            display: none;
        }
        
        .primary-button {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: var(--text-base);
            background-color: var(--accent-secondary);
            border: 1px solid var(--accent-tertiary);
            border-radius: var(--radius-md);
            padding: 0 var(--space-3);
            height: 44px;
            white-space: nowrap;
            font-weight: var(--font-semibold);
            width: 100%;
            
            &:hover {
                background-color: var(--accent-tertiary);
                box-shadow: var(--shadow-md);
            }
        }
        
        .secondary-button {
            display: none;
        }
    }
    
    .batch-converter {
        width: 44px;
        height: 44px;
        min-width: 44px;
        padding: 0;
        display: none;
        align-items: center;
        justify-content: center;
        
        .anticon {
            font-size: 18px;
        }
    }
    
    // Responsive adjustments
    @media (max-width: 1200px) {
        min-height: 40px;
        column-gap: var(--space-1);
        
        .save-button {
            height: 40px;
            font-size: var(--text-sm);
            padding: 0 var(--space-3);
            min-width: 100px;
        }
        
        .imexport {
            grid-template-columns: minmax(70px, auto) 40px var(--space-1) minmax(70px, auto) 40px;
            
            .primary-button {
                height: 40px;
                font-size: var(--text-sm);
                padding: 0 var(--space-2);
            }
            
            ${StyledActionIconButton} {
                height: 40px;
                width: 40px;
                min-width: 40px;
                
                .anticon {
                    font-size: 16px;
                }
            }
        }
        
        .batch-converter {
            width: 40px;
            height: 40px;
            min-width: 40px;
            
            .anticon {
                font-size: 16px;
            }
        }
    }
    
    @media (max-width: 768px) {
        min-height: 36px;
        margin-bottom: var(--space-2);
        
        .save-button {
            height: 36px;
            font-size: var(--text-sm);
            padding: 0 var(--space-2);
            min-width: 80px;
        }
        
        .imexport {
            grid-template-columns: minmax(60px, auto) 36px 4px minmax(60px, auto) 36px;
            
            .primary-button {
                height: 36px;
                font-size: var(--text-xs);
                padding: 0 var(--space-2);
            }
            
            ${StyledActionIconButton} {
                height: 36px;
                width: 36px;
                min-width: 36px;
                
                .anticon {
                    font-size: 14px;
                }
            }
        }
        
        .batch-converter {
            width: 36px;
            height: 36px;
            min-width: 36px;
            
            .anticon {
                font-size: 14px;
            }
        }
        
        .anticon {
            font-size: 14px;
        }
    }
`;

export const CardPreviewContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: auto;
    max-height: calc(100vh - 100px);
    max-width: 100%;
    margin: 0;
    flex-shrink: 2;
    
    /* Always show overlay buttons — no hover-only hiding */
    .reset-button,
    .lightbox-button {
        display: flex !important;
        position: absolute;
        z-index: 10;
        opacity: 0.7;
        transition: opacity 0.2s ease, transform 0.2s ease, background-color 0.2s ease;
    }
    
    &:hover {
        .reset-button,
        .lightbox-button {
            opacity: 1;
        }
    }
    
    .reset-button {
        top: 12px;
        left: 12px;
    }
    
    .lightbox-button {
        top: 12px;
        right: 12px;
    }
    
    #preview-canvas {
        display: none;
        position: relative;
        z-index: 1;
        pointer-events: none;
        max-height: calc(100vh - 100px);
        max-width: 100%;
        width: auto;
        height: auto;
        object-fit: contain;
        border-radius: var(--radius-lg);
        box-shadow: var(--shadow-2xl);
        
        &.js-export-available {
            display: inline-block !important;
            cursor: default;
        }
    }
    
    &:hover {
        .reset-button,
        .lightbox-button {
            display: block;
        }
    }

    /* Mobile Responsive Fixes */
    @media (max-width: 1024px) {
        width: 100% !important;
        max-width: 90vw !important;
        height: auto !important;
        min-height: 400px !important;
        padding: var(--space-4);
        margin: 0 auto;
        overflow: visible !important;
        
        /* Show preview canvas on mobile (it's optimized for display) */
        #preview-canvas {
            display: block !important;
            position: relative !important;
            transform: none !important;
            width: 100% !important;
            height: auto !important;
            max-width: 100% !important;
            left: auto !important;
            top: auto !important;
            pointer-events: all !important;
            z-index: 1 !important;
            margin: 0 !important;
            
            /* Force visibility even without js-export-available class */
            &:not(.js-export-available) {
                display: block !important;
            }
        }

        /* Hide debug canvas on mobile */
        #debug-canvas {
            display: none !important;
        }

        .reset-button,
        .lightbox-button {
            display: block !important;
            position: absolute;
            z-index: 10;
        }

        .reset-button {
            top: 10px;
            left: 10px;
        }

        .lightbox-button {
            top: 10px;
            right: 10px;
        }
    }

    @media (max-width: 768px) {
        max-width: 95vw !important;
        min-height: 350px !important;
        padding: var(--space-3);
        
        #preview-canvas {
            max-width: 100% !important;
        }
    }

    @media (max-width: 480px) {
        max-width: 100vw !important;
        min-height: 300px !important;
        padding: var(--space-2);
        border-radius: 0;
        
        #preview-canvas {
            max-width: 100% !important;
            border-radius: 0 !important;
        }
    }
`;
export const CardCanvasGroupContainer = styled.div`
    width: 100%;
    height: 100%;
    max-height: calc(100vh - 100px);
    max-width: 100%;
    margin-bottom: var(--spacing);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    canvas {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        z-index: 1;
        pointer-events: none;
        max-height: calc(100vh - 100px);
        max-width: 100%;
        object-fit: contain;
        opacity: 0;
        visibility: hidden;
    }
    &:hover {
        #export-canvas.js-export-available {
            display: inline-block !important;   // Override js-controlled inline style
            cursor: default;
        }
        #export-canvas-guard {
            display: flex;
            cursor: wait;
            transition: all 2s;
        }
    }
    #export-canvas {
        display: none;
        z-index: 100;
        pointer-events: all;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-height: calc(100vh - 100px);
        max-width: 100%;
        width: auto;
        height: auto;
        object-fit: contain;
        opacity: 1;
        visibility: visible;
        border-radius: var(--radius-lg);
    }
    #export-canvas-guard {
        position: absolute;
        left: 0;
        display: none;
        align-items: center;
        justify-content: center;
        z-index: 101;
        width: 100%;
        height: 100%;
        .anticon {
            font-size: var(--fs-4xl);
        }
        .canvas-guard-alert {
            position: absolute;
            top: 0;
            right: 0;
            color: white;
            padding: var(--spacing-xs) var(--spacing);
            border-radius: 0 0 0 var(--br-lg);
            background-color: var(--main-active);
            box-shadow:
                0 3px 6px rgba(0, 0, 0, 0.16),
                0 3px 6px rgba(0, 0, 0, 0.23);
        }
        &.guard-on {
            display: flex !important;   // Override js-controlled inline style
        }
    }
    .crop-canvas {
        position: relative;
        /** Size here is just a placeholder, crop canvas constantly get its dimensions updated based on the current artwork */
        width: 416px;
        height: 416px;
        z-index: 0;
        top: 0;
        left: 0;
        visibility: hidden;
    }

    /* Mobile Responsive Fixes */
    @media (max-width: 1024px) {
        position: absolute !important;
        width: 0 !important;
        height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        transform: none !important;
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        left: -9999px !important;
        pointer-events: none !important;
        
        /* Hide ALL canvases in canvas group */
        canvas,
        * {
            display: none !important;
            visibility: hidden !important;
            opacity: 0 !important;
        }
    }
`;

export const StyledAppLoading = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: linear-gradient(135deg, var(--accent-primary) 0%, var(--accent-primary-hover) 100%);
	z-index: 4000;
	color: white;
	font-size: var(--text-2xl);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: var(--space-6);
	
	.spinner-message {
		color: white;
		font-size: var(--text-xl);
		font-weight: var(--font-medium);
		text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
		margin-top: var(--space-4);
	}
`;

export const StyledByMe = styled.div`
	position: fixed;
	right: var(--spacing);
	bottom: 0;
	font-size: var(--fs-xs);
	opacity: 0.5;
	padding: var(--spacing-px) var(--spacing-xs);
	color: var(--color-dim);
    img {
        height: 10px;
        margin-left: 1px;
    }
`;

export const ErrorAlert = styled.span`
    color: var(--main-danger);
`;

export const OverlayButton = styled(CardActionButton)`
    position: absolute;
    z-index: 101;
    width: 40px;
    height: 40px;
    min-width: 40px;
    background-color: rgba(15, 14, 12, 0.85);
    color: var(--brand-gold);
    border: 1px solid rgba(212, 178, 84, 0.4);
    border-radius: 8px;
    transition: all 0.2s ease;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(8px);
    cursor: pointer;
    
    &:hover {
        background-color: var(--brand-gold);
        color: #1A1A1A;
        border-color: var(--brand-gold);
        transform: scale(1.08);
        box-shadow: 0 4px 12px rgba(212, 178, 84, 0.4);
        opacity: 1 !important;
    }
    
    .anticon {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
    }
`;

export const LightboxButton = styled(OverlayButton)`
    top: 12px;
    right: 12px;
`;

export const ResetButton = styled(OverlayButton)`
    top: 12px;
    left: 12px;
`;